import React, { useEffect, createElement } from 'react';
const GTMHeadScript = () => {
  useEffect(() => {
    // Create the script element
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-WDJHH66');`;
    // Add the script to the head
    document.head.appendChild(script);
    // Cleanup function
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount
  return null; // This component doesn't render anything visible
};
export default GTMHeadScript;